import clsxm from "clsxs/clsxm";
import React from "react";

export const Container: React.FC<{
  children?: React.ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return <div className={clsxm("p-4 h-full w-full  overflow-y-auto", className)}>{children}</div>;
};
